import { Component, Shark } from "shark-mvc";
import $ from "jquery";

import templateContent from "./wait-box.html";

class WaitBoxComponent extends Component {
	constructor() {
		super("waitBoxComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			$("#waitBoxModal").modal("show");
		}
	}
	
	close () {
		$(`#waitBoxModal`).modal("hide");
		
		const body = document.querySelector("body");
		body.classList.remove("wait-box-open");

		if (document.querySelectorAll(".modal.show").length === 0){
			body.classList.remove("modal-open");
			body.style.removeProperty("padding-right");
		}
		else {
			body.classList.add("modal-open");
		}

		this.set("open", false);
	}

	hide () {
		this.close();
	}
	
	init () {
		this.set("open", false);
	}
	
	open () {
		document.querySelector("body").classList.add("wait-box-open");
		$(`#waitBoxModal`).modal("show");
		this.set("open", true);
	}

	show () {
		this.open();
	}
}

const waitBoxComponent = new WaitBoxComponent();

Shark.registerComponent(waitBoxComponent);

export default waitBoxComponent;
